import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/903de4eb32376445f3b73b45fb097895/9dff9b4a21cd3814528c6957a2a2f2ab.png" 
              alt="LineFlow Underground & Civil" 
              className="h-20 w-auto"
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <a
              href="/"
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
              }`}
            >
              Home
            </a>
            <a
              href="#services"
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
              }`}
            >
              Services
            </a>
            <a
              href="/projects"
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
              }`}
            >
              Projects
            </a>
            <a
              href="#contact"
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B35]' : 'text-white hover:text-[#FF6B35]'
              }`}
            >
              Contact
            </a>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-6 py-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white font-bold rounded-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Get a Quote
            </button>
          </div>

          <div className="flex items-center gap-6">
            <div className={`hidden lg:flex flex-col gap-1 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              <a href="tel:0410880821" className="flex items-center gap-2 hover:text-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-phone-fill text-lg"></i>
                <span className="font-semibold text-sm">0410 880 821</span>
              </a>
              <a href="tel:0412212971" className="flex items-center gap-2 hover:text-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-phone-fill text-lg"></i>
                <span className="font-semibold text-sm">0412 212 971</span>
              </a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-[#0F4C81]' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white rounded-2xl shadow-xl">
            <div className="flex flex-col gap-4 px-6">
              <a
                href="/"
                className="text-gray-700 font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Home
              </a>
              <a
                href="#services"
                className="text-gray-700 font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Services
              </a>
              <a
                href="/projects"
                className="text-gray-700 font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Projects
              </a>
              <a
                href="#contact"
                className="text-gray-700 font-semibold hover:text-[#FF6B35] transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact
              </a>
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                  setIsMobileMenuOpen(false);
                }}
                className="px-6 py-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white font-bold rounded-lg hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Get a Quote
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
